import ExhibitionTypeContainer from "../../../Component/Application/ExhibitionType/ExhibitionTypeContainer";

const ExhibitionType = () => {
    return (
        <div className="page-body">
            <ExhibitionTypeContainer />
        </div >
    );
};

export default ExhibitionType;